import { ADMIN, ADMIN_DASHBOARD, ADMIN_USERS, ADMIN_USER, ADMIN_USER_EDIT, ADMIN_USER_CREATE, ADMIN_COMPANIES, ADMIN_COMPANY, ADMIN_COMPANY_EDIT, ADMIN_COMPANY_CREATE } from '@/routes/admin'

const AdminView = () => import(/* webpackChunkName: "admin" */'@/views/admin/AdminView')
const AdminDashboardView = () => import(/* webpackChunkName: "admin" */'@/views/admin/AdminDashboardView')
const AdminUsersView = () => import(/* webpackChunkName: "admin" */'@/views/admin/AdminUsersView')
const AdminUserView = () => import(/* webpackChunkName: "admin" */'@/views/admin/AdminUserView')
const AdminUserEditView = () => import(/* webpackChunkName: "admin" */'@/views/admin/AdminUserEditView')
const AdminUserCreateView = () => import(/* webpackChunkName: "admin" */'@/views/admin/AdminUserCreateView')

const AdminCompaniesView = () => import(/* webpackChunkName: "admin" */'@/views/admin/AdminCompaniesView')
const AdminCompanyView = () => import(/* webpackChunkName: "admin" */'@/views/admin/AdminCompanyView')
const AdminCompanyEditView = () => import(/* webpackChunkName: "admin" */'@/views/admin/AdminCompanyEditView')
const AdminCompanyCreateView = () => import(/* webpackChunkName: "admin" */'@/views/admin/AdminCompanyCreateView')

export default [
  {
    path: '/admin',
    component: AdminView,
    meta: {
      titleKey: 'admin.title',
      root: ADMIN,
      mainRoutes: [ ADMIN_DASHBOARD, ADMIN_USERS, ADMIN_COMPANIES ]
    },
    props: true,
    children: [
      {
        path: '',
        name: ADMIN_DASHBOARD,
        component: AdminDashboardView,
        meta: {
          titleKey: 'admin.general.title'
        }
      },
      {
        path: 'users',
        name: ADMIN_USERS,
        component: AdminUsersView,
        meta: {
          titleKey: 'admin.users.title'
        },
        children: [
          {
            path: 'create',
            name: ADMIN_USER_CREATE,
            component: AdminUserCreateView,
            meta: {
              titleKey: 'admin.user.createTitle'
            }
          },
          {
            path: ':userId',
            name: ADMIN_USER,
            component: AdminUserView,
            props: true,
            meta: {
              titleKey: 'admin.user.title'
            }
          },
          {
            path: ':userId/edit',
            name: ADMIN_USER_EDIT,
            component: AdminUserEditView,
            props: true,
            meta: {
              titleKey: 'admin.user.editTitle'
            }
          }
        ]
      },
      {
        path: 'companies',
        name: ADMIN_COMPANIES,
        component: AdminCompaniesView,
        meta: {
          titleKey: 'admin.companies.title'
        },
        children: [
          {
            path: 'create',
            name: ADMIN_COMPANY_CREATE,
            component: AdminCompanyCreateView,
            meta: {
              titleKey: 'admin.company.createTitle'
            }
          },
          {
            path: ':companyId',
            name: ADMIN_COMPANY,
            component: AdminCompanyView,
            props: true,
            meta: {
              titleKey: 'admin.company.title'
            }
          },
          {
            path: ':companyId/edit',
            name: ADMIN_COMPANY_EDIT,
            component: AdminCompanyEditView,
            props: true,
            meta: {
              titleKey: 'admin.company.editTitle'
            }
          }
        ]
      }
    ]
  }
]
